import { useEffect, useState } from "react";
import {
  STREAM_WAIT_VARIANT_COUNT,
  type StreamWaitKind,
} from "@/lib/chat-render-items";

// How long each way of saying a wait stays on screen: brisk enough to show the
// work moving, slow enough to be read.
const WAIT_VARIANT_ROTATION_MS = 3_000;

/**
 * Which variant of the current wait to show. Starts on the plainest one each
 * time the wait changes, then moves on while it lasts — a single line held for
 * twenty seconds reads as a stall as much as no line at all.
 */
export function useWaitVariantIndex(kind: StreamWaitKind | null): number {
  const [rotation, setRotation] = useState({ kind, index: 0 });
  // A new wait opens on its plainest line, even one that was on screen a moment
  // ago: reset while rendering, so the stale variant is never shown.
  if (rotation.kind !== kind) {
    setRotation({ kind, index: 0 });
  }

  useEffect(() => {
    if (!kind) return;
    const timer = setInterval(() => {
      setRotation((current) => ({ kind, index: current.index + 1 }));
    }, WAIT_VARIANT_ROTATION_MS);
    return () => clearInterval(timer);
  }, [kind]);

  if (!kind || rotation.kind !== kind) return 0;
  return rotation.index % STREAM_WAIT_VARIANT_COUNT[kind];
}

